import List from "@/components/list";
import Bus from "./Bus.js";
//import router from "@/router";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  function handleRemove({ row }) {
    Bus.$emit("removeComment", row);
  }
  function handleReback({ row }) {
    Bus.$emit("rebackComment", row);
  }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-back", "恢复", () => handleReback(vo), "comment:delete"],
      ["icon-delete", "删除", () => handleRemove(vo), "comment:remove"]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "评论内容",
      prop: "commentContent",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "资源名称",
      prop: "bizName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "评论人",
      prop: "createUserName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "删除原因",
      prop: "delReason",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "评论时间",
      prop: "createDate",
      minWidth: "130"
    },
    {
      label: "操作",
      minWidth: "100",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
